<template>
	<div class="wc-fixed-bar">
		<button v-if="checkoutLoading" class="btn btn-green btn-cart-box btn-icon-arrow btn-submit btn-spinner"></button>
		<div v-else-if="(!meta?.valid || !formValid) || orderData?.cart?.can_change_payment == false" class="btn btn-fixed-bar btn-green btn-cart-box btn-icon-arrow btn-submit btn-disabled">
			<template v-if="props.mode == 'newPaymentMode'"><BaseCmsLabel code="confirm_new_payment" /></template>
			<template v-else><BaseCmsLabel code="paid" /></template>
		</div>
		<button v-else class="btn btn-fixed-bar btn-green btn-cart-box btn-icon-arrow btn-submit" type="submit">
			<template v-if="props.mode == 'newPaymentMode'"><BaseCmsLabel code="confirm_new_payment" /></template>
			<template v-else><BaseCmsLabel code="paid" /></template>
		</button>
	</div>
</template>

<script setup>
	const labels = useLabels();
	const props = defineProps(['review', 'mode', 'meta']);
	const { checkoutLoading, formValid, orderData } = useCheckout();
</script>

<style lang="less" scoped>
	.wc-fixed-bar{
		display: none; align-items: center; padding: 10px 15px; background: @white; position: fixed; bottom: 0; left: 0; right: 0; box-shadow: 0 0 20px 0 rgba(0,37,69,0.2); z-index: -1;

		@media (max-width: @m){display: flex; justify-content: space-between; z-index: 1111;}
	}
	.btn-fixed-bar{
		display: flex; width: 100%; height: 50px; padding: 0 30px; font-size: 15px;
		span:before{font-size: 9px; top: 6px;}
	}
</style>
